import React from 'react';
import { Container, Typography, Button, Box, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function StripeRefreshPage() {
    const theme = useTheme();
    return (
        <Box
            sx={{
                position: 'relative',
                height: '100vh',
                backgroundImage: 'url(/static/images/overview/onlyfishbackground2.webp)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                p: 3,
            }}
        >
            <Container
                maxWidth="sm"
                sx={{
                    zIndex: 2,
                    backgroundColor: theme.palette.background.default, 
                    padding: 4,
                    borderRadius: 2,
                    boxShadow: 3,
                }}
            >
                <Typography variant="h4" component="h1" gutterBottom>
                    Stripe Onboarding Incomplete
                </Typography>
                <Typography variant="body1" color="text.secondary" paragraph>
                    It seems like your Stripe account onboarding wasn't completed. You can retry the process by clicking the button below.
                </Typography>

                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    component={RouterLink}
                    to="/retry-stripe-onboarding" // Link to retry onboarding
                    sx={{ mt: 2 }}
                >
                    Retry Onboarding
                </Button>

                <Typography variant="body2" color="text.secondary" sx={{ mt: 4 }}>
                    If you continue to face issues, please contact our support team.
                </Typography>
            </Container>

            {/* Background overlay for better contrast */}
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.4)',
                    zIndex: 1,
                }}
            />
        </Box>
    );
}
